var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _circle2, _circle3, _path, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangelog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EEF0F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1641,
    y: 5.01416,
    width: 16.102,
    height: 22.2462,
    rx: 1.27121,
    transform: "rotate(13.3951 13.1641 5.01416)",
    fill: "#E4E5E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19141,
    y: 7.1499,
    width: 16.102,
    height: 22.2462,
    rx: 1.27121,
    transform: "rotate(0.157191 8.19141 7.1499)",
    fill: "url(#paint0_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4922,
    y: 17.9614,
    width: 9.74597,
    height: 1.05934,
    rx: 0.529672,
    transform: "rotate(0.157191 10.4922 17.9614)",
    fill: "#CCD0D4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4863,
    y: 20.292,
    width: 6.35607,
    height: 1.05934,
    rx: 0.529672,
    transform: "rotate(0.157191 10.4863 20.292)",
    fill: "#CCD0D4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4785,
    y: 22.8345,
    width: 8.68663,
    height: 1.05934,
    rx: 0.529672,
    transform: "rotate(0.157191 10.4785 22.8345)",
    fill: "#CCD0D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9918,
    cy: 11.8485,
    r: 3.50536,
    transform: "rotate(0.157191 13.9918 11.8485)",
    fill: "#498BEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.9917,
    cy: 11.8481,
    r: 2.7493,
    transform: "rotate(0.157191 13.9917 11.8481)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9969 9.99213C14.4342 9.99333 14.7863 10.3445 14.7851 10.7784C14.7839 11.2123 14.4299 11.5616 13.9926 11.5604C13.5552 11.5592 13.2031 11.208 13.2043 10.7741C13.2055 10.3402 13.5595 9.99093 13.9969 9.99213ZM13.9867 13.7037C13.328 13.7019 12.7466 13.3657 12.4081 12.8577C12.4175 12.3376 13.4642 12.0556 13.9912 12.057C14.5155 12.0584 15.5634 12.3462 15.5698 12.8664C15.2286 13.3725 14.6454 13.7055 13.9867 13.7037Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2734,
    y: 13.3618,
    width: 2.46605,
    height: 14.7963,
    transform: "rotate(-19.4284 21.2734 13.3618)",
    fill: "#F9BF42"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2734,
    y: 13.3618,
    width: 1.64403,
    height: 14.7963,
    transform: "rotate(-19.4284 21.2734 13.3618)",
    fill: "#F5AA2C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0488,
    y: 13.0884,
    width: 0.822015,
    height: 14.7963,
    transform: "rotate(-19.4284 22.0488 13.0884)",
    fill: "#F5B52C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1953,
    y: 27.3154,
    width: 2.46605,
    height: 0.822015,
    transform: "rotate(-19.4284 26.1953 27.3154)",
    fill: "#FF6020"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1953,
    y: 27.3154,
    width: 0.823009,
    height: 0.823009,
    transform: "rotate(-19.4284 26.1953 27.3154)",
    fill: "#D73D01"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9707,
    y: 27.042,
    width: 0.823009,
    height: 0.823009,
    transform: "rotate(-19.4284 26.9707 27.042)",
    fill: "#FF4A01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4688 28.0908L28.7944 27.2705L29.0678 28.0458C29.2188 28.4739 28.9942 28.9434 28.566 29.0944L27.7908 29.3678C27.3627 29.5188 26.8932 29.2942 26.7422 28.866L26.4688 28.0908Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1919 9.47292L23.5965 12.5472L21.248 13.3755L21.1919 9.47292Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.192 9.47277L21.999 10.508L21.2131 10.7852L21.192 9.47277Z",
    fill: "#676C71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.7921,
    y1: 9.21783,
    x2: 10.8451,
    y2: 23.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.6015,
    y1: 10.0779,
    x2: 23.8329,
    y2: 12.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangelog);
export default __webpack_public_path__ + "static/media/changelog.e2f1e73f8c27a9a066c2a461e0028e02.svg";
export { ForwardRef as ReactComponent };